// Lib
import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { Box, ClickAwayListener } from '@mui/material';

// Components
import Input from '../../Field/Input';

// Hooks
import useUser from '../../../hooks/useUser';
import useCountButton from '../../../hooks/useCountButton';

// Utils
import isDigitalAsset from '../../../utils/isDigitalAsset';

import { useStyles } from './CountButtonStyles';

const CountButton = ({
  count = 0,
  onAdd,
  onRemove,
  onSetCount,
  product,
  active = true, // when false, buttons become grey
  error = false, // when true, button become red
  disabled = false, // when true, you can't change value
  limitValue = true, // doesn't let to enter qty > than available
  className,
  onClickAway,
}) => {
  const { isKiteUser } = useUser();
  const { classes, cx } = useStyles({
    isKiteUser,
    active,
    error,
    disabled,
  });

  const { onChange, onFocus, onBlur, value } = useCountButton(
    product,
    count,
    onSetCount,
    limitValue,
  );

  if (isDigitalAsset(product)) {
    return null;
  }

  return (
    <ClickAwayListener
      onClickAway={(e) => {
        onClickAway && onClickAway();
        e.stopPropagation();
      }}>
      <Box
        id="count-button"
        className={cx(classes.button, className, classes.relativeBox)}
        display="flex"
        justifyContent="space-between">
        <RemoveIcon
          id="count-minus-button"
          className={classes.icon}
          onClick={onRemove}
        />
        <Input
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          disabled={disabled}
          id="count-input"
          className={classes.input}
          value={value}
        />
        <AddIcon
          id="count-plus-button"
          className={classes.icon}
          onClick={onAdd}
        />
      </Box>
    </ClickAwayListener>
  );
};

export default CountButton;
